import React from 'react';
import BenefitReportProvider from '~/views/Report/Benefit/context/BenefitReportContext';
import { CardProvider } from '~/views/Report/Card/context/CardContext';
import FinancialReportProvider from '~/views/Report/Financial/context/FinancialReportContext';
import { InvoiceProvider } from '~/views/Report/Invoice/context/InvoiceContext';
import ProposalReportProvider from '~/views/Report/Proposal/context/ProposalReportContext';
import AccessionSaleReportProvider from '~/views/Report/Wallet/context/AccessionSaleReportContext';

import { ModalProvider } from '~/hooks/useModal';
import { FilterBiometricProvider } from '~/views/Consult/FacialBiometrics/context/FilterBiometricContext';
import { InvoiceReprocessProvider } from '~/views/Invoice/Reprocess/context';
import EventReportProvider from '~/views/Report/Events/context/EventReportContext';
import LoanReportProvider from '~/views/Report/Loan/context/LoanReportContext';
import SharedBenefitServiceProvider from '~/views/Sales/EventsCenter/Benefits/Services/sharedBenefitServiceProvider';
import SharedCardServicesProvider from '~/views/Sales/EventsCenter/Card/Services/sharedCardServiceProvider';
import SharedServiceProvider from '~/views/Sales/EventsCenter/Services/sharedServiceProvider';
import { AuthProvider } from './authentication';
import { LeadProvider } from './leads';
import { ProposalProvider } from './proposal';

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <ProposalReportProvider>
      <ProposalProvider>
        <LeadProvider>
          <BenefitReportProvider>
            <AccessionSaleReportProvider>
              <CardProvider>
                <LoanReportProvider>
                  <EventReportProvider>
                    <InvoiceProvider>
                      <FinancialReportProvider>
                        <SharedServiceProvider>
                          <SharedCardServicesProvider>
                            <SharedBenefitServiceProvider>
                              <FilterBiometricProvider>
                                <InvoiceReprocessProvider>
                                  <ModalProvider>{children}</ModalProvider>
                                </InvoiceReprocessProvider>
                              </FilterBiometricProvider>
                            </SharedBenefitServiceProvider>
                          </SharedCardServicesProvider>
                        </SharedServiceProvider>
                      </FinancialReportProvider>
                    </InvoiceProvider>
                  </EventReportProvider>
                </LoanReportProvider>
              </CardProvider>
            </AccessionSaleReportProvider>
          </BenefitReportProvider>
        </LeadProvider>
      </ProposalProvider>
    </ProposalReportProvider>
  </AuthProvider>
);

export default AppProvider;
